import React from 'react';

//style
import './style.scss';

const Pagination = ({
  projectsPerPage,
  totalProjects,
  paginate,
  currentPage,
  decrementPaginate,
  incrementPaginate,
}) => {
  let pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalProjects / projectsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      <ul className="pagination">
        {currentPage > 1 && (
          <li className="page-link prevPage" onClick={decrementPaginate}>
            <i className="fas fa-chevron-left"></i>
          </li>
        )}
        {pageNumbers.map((number) => (
          <li key={number} className="page-item">
            {' '}
            <span
              onClick={() => paginate(number)}
              className={
                currentPage === number ? 'acitve-link page-link' : 'page-link'
              }
            >
              {' '}
              {number}{' '}
            </span>{' '}
          </li>
        ))}
        {pageNumbers.length > currentPage && (
          <li className="page-link prevPage" onClick={incrementPaginate}>
            <i className="fas fa-chevron-right"></i>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Pagination;
